import React from 'react';

import { Popover } from '@blueprintjs/core';
import { Link } from 'react-router-dom';

import { Text } from 'common-components/typography';
import { ActionMenu, ActionMenuItem } from 'common-components/action-menu';
import CommonUtils from 'utilities/common-utils';
import { ActionIcon, Avatar, Box } from '@good/ui/core';
import { MoreHoriz } from '@good/icons';

export function CustomerDetailsColumn({
  customerId,
  customerName,
  revenueAmount,
  avatarUrl,
}: {
  customerId: string;
  customerName: string;
  revenueAmount: number;
  avatarUrl: string;
}) {
  return (
    <Box className='flex-row  justify-between' p='sm'>
      <div className='flex-row' style={{ maxWidth: 200 }}>
        <Avatar mr='sm' src={avatarUrl} name={customerName} />
        <div className='line-height-135 block text-overflow-ellipsis overflow-hidden whitespace-nowrap'>
          <Text lineHeight={120}>{customerName}</Text>
          <br />
          <Text size='regular' color='secondary' lineHeight={135}>
            {CommonUtils.formatPrice(revenueAmount)}
          </Text>
        </div>
      </div>
      <Popover
        content={
          <ActionMenu>
            <Link to={`/customer/details/${customerId}`} className='underline-none'>
              <ActionMenuItem text={'View customer profile'} />
            </Link>
          </ActionMenu>
        }
        position={'bottom-left'}
      >
        <ActionIcon variant='default'>
          <MoreHoriz />
        </ActionIcon>
      </Popover>
    </Box>
  );
}
